module.exports = __webpack_public_path__ + "static/enable-email-verify-switch-535e79fa7c37275efef83c8c662d9c1c.png";